import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowDownLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M17.5 4.37866L8 13.8787V7.99998H5V19H16V16H10.1213L19.6213 6.49998L17.5 4.37866Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowDownLeft;
